module.exports = __webpack_public_path__ + "img/finance_apply3.5285e080.png";